import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface LoanTableBreakDownPropsHook {
  classNames: {
    wrapperClassName: string;
    poundsClassName: string;
    centsClassName: string;
  };
  searchWords: string[];
}

export default function useLoanTableBreakDownProps(): LoanTableBreakDownPropsHook {
  const [query] = useQuery("loans");

  const searchWords = useSearchWords(query);

  const classNames = {
    wrapperClassName: "my-auto",
    poundsClassName: "text-12-18-em",
    centsClassName: "text-12-18-em",
  };

  return {
    classNames,
    searchWords,
  };
}
